export const FINE = 'FINE';
export const FURNISHING = 'FURNISHING';
export const FURNITURE_ASSEMBLING = 'FURNITURE_ASSEMBLING';
export const ROUGH = 'ROUGH';
